const initialvalues = {
    Dashboardlogindetails: {},
    serviceslist: {},
    serviceid: 0,
    condtionReportVal: null,
    condtionReportTrade: null,
    condtionReportCellTower: null,
    condtionReportTapFee: null,
    condtionReportAuction: null,
    condRoleId: 0,
    bulkdownload: {},
    modulesSideBarData: {},
    condtionPanchayatProfile: null, activeTabIndex: 0



};
export default function ServiceDashboardReducer(details = initialvalues, action) {
    switch (action.type) {
        case "SERVICES_LIST":
            return { ...details, serviceslist: action.payload };
        case "SERVICE_ID":
            return { ...details, serviceid: action.payload };
        case "CONDITION_REPORT_VALUE":
            return { ...details, condtionReportVal: action.payload };
        case "CONDITION_REPORT_TRADE":
            return { ...details, condtionReportTrade: action.payload };
        case "CONDITION_REPORT_CELL_TOWER":
            return { ...details, condtionReportCellTower: action.payload };

        case "CONDITION_REPORT_TAP_FEE":
            return { ...details, condtionReportTapFee: action.payload };

        case "CONDITION_REPORT_AUCTION":
            return { ...details, condtionReportAuction: action.payload };
        case "DASH_BOARD_LOGIN":
            return { ...details, Dashboardlogindetails: action.payload };

        case "ROLE_ID":
            return { ...details, condRoleId: action.payload };
        case "BULKDOWNLOAD":
            return { ...details, bulkdownload: action.payload };
        case "MODULES_SIDE_BAR_DATA":
            return { ...details, modulesSideBarData: action.payload };

        case "PANCHAYAT_PROFILE_COUNT":
            return { ...details, condtionPanchayatProfile: action.payload };
        case "ACTIVE_TAB":
            return {
                ...details,
                activeTabIndex: action.payload,
            };

        default:
            return details;
    }
}